import { Listbox } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { DropdownChevronUpSvg } from 'apps/sigma2-ui/src/components/svg/DropdownChevronUp';
import { DropdownChevronDownSvg } from 'apps/sigma2-ui/src/components/svg/DropdownChevronDown';

export type SelectOption<TValue extends string> = {
  label: string;
  value: TValue;
};

export interface SimpleSelectProps<TValue extends string> {
  selectedOptionValue: TValue;
  options: SelectOption<TValue>[];
  updateOptions: (newSelection: TValue) => void;
  disabled?: boolean;
}

export const SimpleSelect = <TValue extends string>({
  selectedOptionValue,
  options,
  disabled,
  updateOptions,
}: SimpleSelectProps<TValue>) => {
  return (
    <Listbox
      value={selectedOptionValue}
      onChange={updateOptions}
      disabled={disabled}
    >
      {({ open }) => (
        <div className="relative">
          <Listbox.Button className="w-full px-2 py-1 bg-white h-[29px] border-solid border-1 border-gray-400 rounded-[4px] flex flex-row items-center">
            <span className="text-sm font-sans text-left text-gray-800 font-bold truncate flex-1">
              {options.find((o) => o.value === selectedOptionValue)?.label ??
                ''}
            </span>
            {open ? (
              <DropdownChevronUpSvg
                svg={{ className: 'w-4 h-[17px] block text-secondary' }}
              />
            ) : (
              <DropdownChevronDownSvg
                svg={{ className: 'w-4 h-[17px] block text-secondary' }}
              />
            )}
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute left-0 z-tooltip-standout w-full mt-1 overflow-auto bg-white border-gray-400 rounded-lg shadow-8px max-h-60 border-1 focus:outline-none">
              {options.map((option, optionIdx) => (
                <Listbox.Option
                  key={optionIdx}
                  className={({ active }) =>
                    `w-full bg-white pt-2 pb-2 px-2 font-sans text-sm leading-[21px] left-0 cursor-pointer ${
                      active ? 'text-secondary' : 'text-gray-800'
                    }`
                  }
                  value={option.value}
                >
                  {() => (
                    <>
                      <span className={`block truncate`}>{option.label}</span>
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
};
